import { CountryCode } from '../countryCodes'

const downloadBadges = (type: 'android' | 'ios') => ({
  /* eslint-disable @typescript-eslint/camelcase */
  bg: require(`../../assets/badges/${type}/bg.svg`),
  cz: require(`../../assets/badges/${type}/cz.svg`),
  de: require(`../../assets/badges/${type}/de.svg`),
  el: require(`../../assets/badges/${type}/en.svg`),
  en: require(`../../assets/badges/${type}/en.svg`),
  es: require(`../../assets/badges/${type}/es.svg`),
  fil: require(`../../assets/badges/${type}/en.svg`), //Brakuje tłumaczenia odznaki dla ios
  fr: require(`../../assets/badges/${type}/fr.svg`),
  hr: require(`../../assets/badges/${type}/en.svg`),
  hu: require(`../../assets/badges/${type}/hu.svg`),
  in: require(`../../assets/badges/${type}/en.svg`),
  it: require(`../../assets/badges/${type}/it.svg`),
  ja: require(`../../assets/badges/${type}/en.svg`),
  ko: require(`../../assets/badges/${type}/en.svg`),
  ms: require(`../../assets/badges/${type}/en.svg`),
  pl: require(`../../assets/badges/${type}/pl.svg`),
  pl_PL: require(`../../assets/badges/${type}/pl_PL.svg`),
  pt: require(`../../assets/badges/${type}/pt.svg`),
  pt_BR: require(`../../assets/badges/${type}/pt_BR.svg`),
  ro: require(`../../assets/badges/${type}/en.svg`),
  ru: require(`../../assets/badges/${type}/ru.svg`),
  se: require(`../../assets/badges/${type}/se.svg`),
  th: require(`../../assets/badges/${type}/en.svg`),
  tr: require(`../../assets/badges/${type}/tr.svg`),
  uk: require(`../../assets/badges/${type}/en.svg`),
  /* eslint-enable */
})

export default function(type: 'android' | 'ios', lng: CountryCode) {
  return downloadBadges(type)[lng]
}
